import { SVGProps } from 'react';

const TriangleDashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.17 4.193a2 2 0 0 1 3.666.013M14 21h2m-.126-13.257 1 1.732m1.975 3.477 1 1.732m1.975 3.496a2 2 0 0 1-1.835 2.824M4.024 21a2 2 0 0 1-1.839-2.84m2.951-5.208-1 1.732M8 21h2M8.102 7.743l-1 1.732"
    />
  </svg>
);
export default TriangleDashed;
